
export function formatDateForPost(date) {
  const now = new Date();
  const diffMs = now - date;
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) return "just now";
  if (diffMinutes === 1) return "1 minute ago";
  if (diffMinutes < 60) return `${diffMinutes} minutes ago`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours === 1) return `1 hour ago`;
  if (diffHours < 24) return `${diffHours} hours ago`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return `1 day ago`;
  if (diffDays < 30.416667) return `${diffDays} days ago`;

  const diffMonths = Math.floor(diffDays / 30.416667);
  if (diffMonths === 1) return `1 month ago`;
  if (diffMonths < 12) return `${diffMonths} months ago`;
  
  const reformedDate = date;
    const options = { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric', 
        hour: 'numeric', 
        minute: '2-digit', 
        hour12: true 
    };
    return Intl.DateTimeFormat('en-US', options).format(reformedDate);
}
